import type { WithT } from 'i18next';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Flight } from '@feathr/blackbox';
import { ModalV1, toast } from '@feathr/components';

import FlightPathSettings from './FlightPathSettings';

interface IProps {
  flight: Flight;
  toggleModal: () => void;
}

function onConfirm({ flight, t, toggleModal }: IProps & WithT) {
  return async () => {
    try {
      await flight.save();
      if (flight.collection) {
        flight.collection.refreshApiCache();
      }
      toast(t('Updated settings.'), { type: 'success' });
      toggleModal();
    } catch {
      toast(t("Couldn't save settings. Try again."), { type: 'error' });
    }
  };
}

function MakeSharedFlightModal({ flight, toggleModal }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  return (
    <ModalV1
      controlled={true}
      ephemeral={true}
      onClose={toggleModal}
      onConfirm={onConfirm({ flight, t, toggleModal })}
      t={t}
      title={t('Make flight path')}
    >
      <FlightPathSettings flight={flight} />
    </ModalV1>
  );
}

export default observer(MakeSharedFlightModal);
